export default __webpack_public_path__ + "static/media/YA_SABE.6c4f985f.png";